import React from 'react'

export default ({ className = 'card-loader' }) => {
  return (
    <div className="card-loader-container">
      <div 
        className={`circle-loader ${className}`} />
    </div>
  )
}